<template lang="pug">
  .xj-apr-flow
    .header
      img(src="../../../public/images/xinjiang/apr-header.jpeg")
    .form-area
      .form-item
        input(placeholder="请输入新疆移动手机号", v-model="form.mobile")
      .form-item
        el-row
          el-col(:span="14")
            input.txt-verifyCode(placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength='6')
          el-col(:span="10")
            button.btn-verifyCode(type="button", :disabled="leftSendTime > 0", @click="sendVerifyCode")
              span(v-if="leftSendTime <= 0") 获取验证码
              span(v-else) {{leftSendTime}}秒后可重试
      button.btn-submit(type="button", @click="handleSubmit") 立即抢购 &gt;&gt;
    .notice
      ul
        li(v-for="(notice, index) in notices", :key="index")
          .num {{index + 1}}.
          p.content {{notice}}
</template>

<script>
export default {
  name: 'XJAprFlow',
  data() {
    return {
      leftSendTime: 0,
      notices: [
        '本活动仅限新疆移动用户参加，欠费、黑名单、停机用户不可办理。',
        '资费15元/月，包含Koznak、腾讯视频、爱奇艺等视频类、阅读类、音乐类19项会员权益每月任意选取1项+3GB全国通用流量+1GB定向流量，资费长期有效。活动办理立即生效，前6个月每月返5.1元话费，合约期12个月内不允许退订原业务。',
        '该产品需要扣除话费办理，办理之前话费余额需要大于办理套餐的费用，该业务办理成功后不能抵扣之前超出的流量。。',
        '订购优惠后，每自然月1日起至自然月月底，可在19项会员中任意领取1项，领取的会员有效期一般为30或31天；次月可根据您的需求，领取其他会员。请进入：新疆移动微信公众号-权益中心-立即登陆-领取记录-立即领取进行权益领取。',
        '19项会员权益每月任选1：爱奇艺VIP黄金会员、优酷VIP会员、腾讯视频VIP会员、芒果TV-VIP会员、PP视频影视会员、咪咕视频钻石会员；QQ音乐绿钻豪华版会员、酷我音乐豪华VIP会员、酷狗音乐豪华VIP会员、咪咕音乐白金会员；掌阅VIP会员、QQ阅读会员、书旗小说会员、咪咕阅读至尊会员；喜马拉雅会员、蜻蜓FM超级会员；作业帮VIP会员、讯飞语记；Koznak会员。',
        '会员权益每月均需领取一次，当月的会员权益需在当月领取，未领取则次月不能补领。',
        '查询方式：办理成功会收到10086下发的办理成功短信，或者拨打10086人工客服核实。',
        '注意事项：请确认手机号码、验证码输入正确。'
      ],
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 13,
        userId: '',
        goodsCode: 'TUIA2021040801'
      },
      channel: 'TUIA',
      showMoreNotice: false
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.form.goodsCode,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.form.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            if (window.countLog) {
              window.countLog.ready(function() {
                window.countLog.init(function() { 
                }, {
                  isCopy: 0, 
                  pageType: 0 
                })
              })
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'xjFlowSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.xj-apr-flow{
  background-color: #008cdb;
  padding-bottom: 5rem;
  img{
    width: 100%;
  }
  .form-area{
    width: 80%;
    margin: 0 auto;
    margin-top: -55vw;
    .form-item{
      margin-bottom: 1rem;
      input{
        width: 100%;
        border-radius: .8rem;
        font-size: 1rem;
        border: 0;
        padding: 0 1rem;
        height: 2.6rem;
        line-height: 2.6rem;
        box-sizing: border-box;
      }
      .txt-verifyCode{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    button{
      width: 100%;
      border: 0;
    }
    .btn-submit{
      border-radius: 2rem;
      font-size: 1.2rem;
      padding: .6rem 0;
      background-color: #ffc64d;
      box-shadow: 0 3px 1px #3f3f3f;
      color: #fff;
      margin-top: .6rem;
    }
    .btn-verifyCode{
      font-size: 1rem;
      border: 0;
      height: 2.6rem;
      line-height: 2.6rem;
      background-color: #fff;
      border-top-right-radius: .8rem;
      border-bottom-right-radius: .8rem;
      color: #7c5328;
    }
  }
  .notice{
    position: relative;
    width: 90%;
    margin: 0 auto;
    margin-top: 3rem;
    border-radius: 12px;
    background-image: url('../../../public/images/xinjiang/apr-notice-header.png');
    background-size: 100%;
    background-repeat: no-repeat;
    padding-top: 2.4rem;
    padding-bottom: 1.6rem;
    &::after{
      content: " ";
      position: absolute;
      bottom: 0;
      background-image: url('../../../public/images/xinjiang/apr-notice-bottom.png');
      background-size: 100%;
      background-repeat: no-repeat;
      height: 3rem;
      width: 100%;
    }
    ul{
      background: #fff;
      padding: 1rem;
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #333;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
  }
}
</style>